module.exports = __webpack_public_path__ + "media/images/games/35gender/orange-24b7e19ded237e539826325d5815dbc9.png";